import { render } from "./home.vue?vue&type=template&id=b601f924&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=b601f924&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-b601f924"

export default script